<template>
  <b-input-group class="ad-name-field">
    <b-form-input
      :id="id"
      ref="input"
      :value="value"
      :state="state"
      :placeholder="placeholder"
      type="text"
      @input="onInput"
    />
    <b-input-group-append>
      <b-dropdown
        variant="outline-secondary"
        right
        no-caret
        menu-class="ad-name-field__menu"
        toggle-class="ad-name-field__toggle"
        :toggle-attrs="{ title: 'Insert variable', 'aria-label': 'Insert variable' }"
      >
        <template #button-content>
          <GjIcon name="Bracket" />
        </template>
        <b-dropdown-item
          v-for="key in variables"
          :key="key"
          link-class="ad-name-field__item"
          :disabled="isUsed(key)"
          @click="insertToken(key)"
        >
          <code class="ad-name-field__token">{{ formatToken(key) }}</code>
        </b-dropdown-item>
      </b-dropdown>
    </b-input-group-append>
  </b-input-group>
</template>

<script>
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'

export default {
  components: { GjIcon },
  props: {
    value: { type: String, default: '' },
    variables: { type: Array, required: true },
    state: { type: Boolean, default: null },
    id: { type: String, default: '' },
    placeholder: { type: String, default: '' },
  },
  methods: {
    formatToken(key) {
      return `{{${key}}}`
    },
    isUsed(key) {
      const escaped = key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
      const re = new RegExp(`\\{\\{\\s*${escaped}\\s*\\}\\}`)
      return re.test(this.value || '')
    },
    onInput(value) {
      this.$emit('input', value)
    },
    insertToken(key) {
      const token = this.formatToken(key)
      const inputEl = this.$refs.input && this.$refs.input.$el
      const current = this.value || ''
      const start = inputEl && inputEl.selectionStart != null ? inputEl.selectionStart : current.length
      const end = inputEl && inputEl.selectionEnd != null ? inputEl.selectionEnd : current.length
      const before = current.slice(0, start)
      const after = current.slice(end)
      const prev = before.slice(-1)
      const needsSep = prev && !/[\s_\-.]/.test(prev)
      const insertion = (needsSep ? '_' : '') + token
      const next = before + insertion + after
      this.$emit('input', next)
      this.$nextTick(() => {
        if (!inputEl) return
        inputEl.focus()
        const cursor = start + insertion.length
        if (typeof inputEl.setSelectionRange === 'function') {
          inputEl.setSelectionRange(cursor, cursor)
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.ad-name-field {
  ::v-deep .ad-name-field__toggle {
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0 0.85rem;
  }

  ::v-deep .ad-name-field__menu {
    min-width: 0;
    padding: 0.25rem 0;
    border-radius: 6px;
    box-shadow: 0 4px 16px rgba(34, 41, 47, 0.12);
  }

  ::v-deep .ad-name-field__item {
    padding: 0.4rem 1rem;
  }

  ::v-deep .ad-name-field__token {
    font-size: 0.8rem;
    background: transparent;
    color: inherit;
    padding: 0;
  }
}
</style>
